import React, { useState, useEffect } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { Col, Row, Button, Modal, NavDropdown } from "react-bootstrap";
import { GetAdminNotification, GetNotification } from "../../../utils/axios/NotificationAPI";
import { ConfirmAlert } from "../../../utils/swtAlert";
import { GetUserById } from '../../../utils/axios/UserApi';
import { Decrypt } from '../../../utils/Helper';
import { GetOrganizationById } from "../../../utils/axios/CompanyAPI";
import { Encrypt } from "../../../utils/Helper";
import { GetStudentsById } from "../../../utils/axios/StudentAPI";
import { getRoles } from '../../../utils/swtAlert';
import { GrokLoading } from '../../page-layout/loading/Loading';
import { ROLE } from "../../constants/constants";

function Header({ reloadHeader }) {

  const navigate = useNavigate();
  const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
  const [userDetails, setUserDetails] = useState('');
  const [companiesList, setCompaniesList] = useState([]);
  const [collegesList, setCollegesList] = useState([]);
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(false);
  const [notificationCount, setNotificationCount] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [studentNotificationCount, setStudentNotificationCount] = useState([]);

  const [showCompaniesList, setShowCompaniesList] = useState(true);
  const [organizationId, setOrganizationId] = useState('');
  const [organizationDetail, setOrganizationDetail] = useState();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [companiesListFiltered, setCompaniesListFiltered] = useState([]);
  const [collegesListFiltered, setCollegesListFiltered] = useState([]);
  const body = document.querySelector("body");
  const onToggleClick = (e) => {
    body.classList.toggle("isnavabr-active");
  };

  const handleShowOrganizationList = () => {
    if (document.getElementById('company').checked === true) {
      setShowCompaniesList(true);
    }
    else {
      setShowCompaniesList(false);
    }
  }

  const switchOrganization = () => {
    let filteredOrganization = []

    if (showCompaniesList) {
      filteredOrganization = companiesList.filter((item) => item.Name === organizationId);
    }
    else {
      filteredOrganization = collegesList.filter((item) => item.Name === organizationId);
    }

    changeOrganization(filteredOrganization[0]._id);
  }

  const getSelectedOrganization = async (orgId) => {
    setLoading(true);
    var organizationResponse = await GetOrganizationById(orgId);
    setLoading(false);
    if (organizationResponse) {
      return organizationResponse?.data[0]
    }
  }

  const getAdminNotification = async () => {
    let adminnotificationResponse = await GetAdminNotification();
    setNotificationCount(adminnotificationResponse?.data?.MarkAsUnReadCount);
  }

  const getUserName = async () => {
    let getUserNameResponse = await GetUserById(userInfo._id);
    console.log(getUserNameResponse?.data?.RoleId?.Name);

    if (getUserNameResponse?.data?.RoleId?.Name === "Student") {
      setShowNotification(true)
    }
  }

  const getNotification = async () => {
    let getMyStudentNotification = {
      StudentId: userInfo.StudentId
    }
    let studentNotificationResponse = await GetNotification(getMyStudentNotification);
    setStudentNotificationCount(studentNotificationResponse?.data?.MarkAsUnReadCount);
  }

  const changeOrganization = async (orgId) => {
    var organizationData = await getSelectedOrganization(orgId);
    setOrganizationDetail(organizationData);
    handleClose();
    var orgId = organizationData._id;
    var updatedUserInfo = JSON.parse(Decrypt(sessionStorage.getItem('userInfo')));
    updatedUserInfo.OrganizationId = orgId;
    sessionStorage.removeItem('userInfo');
    sessionStorage.setItem('userInfo', Encrypt(JSON.stringify(updatedUserInfo)));
    navigate("/home", { replace: true });
  }

  const logout = () => {
    ConfirmAlert("You want to logout!", 'Are you sure?', 'warning', 'Yes, log me out!')
      .then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem('user')
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userDetails");
          sessionStorage.removeItem("orgDetail");
          const theme = localStorage.getItem('theme');
          localStorage.setItem('closeTabTheme', theme);
          localStorage.setItem('theme', 'light');
          document.documentElement.setAttribute('data-theme', 'light');
          navigate("/businesschallenges");
        }
      })
  };

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setOrganizationId('');
  }

  const [profileShow, setProfileShow] = useState(false);
  const handleCloseProfile = () => setProfileShow(false);
  const handleShowProfile = () => setProfileShow(true);

  const handleOptionClick = (name) => {
    setOrganizationId(name);
  }

  const openNotification = () => {
    navigate('/notifications');
  }

  const getUser = async () => {
    var userResponse = await GetUserById(userInfo._id);

    sessionStorage.setItem("userDetails", Encrypt(userResponse.data));
    setUserDetails(Decrypt(sessionStorage.getItem('userDetails')));

    if (userInfo.StudentId) {
      var studentResponse = await GetStudentsById(userInfo.StudentId);
      var newUserDetails = Decrypt(sessionStorage.getItem('userDetails'));
      const { Year, Branch, Semester } = studentResponse.data;
      newUserDetails.Year = Year.name;
      newUserDetails.Branch = Branch.name;
      newUserDetails.Semester = Semester.name;
      sessionStorage.setItem("userDetails", Encrypt(newUserDetails));
      setUserDetails(Decrypt(sessionStorage.getItem('userDetails')));
    }
  }
  const getOrg = async () => {
    if (!(sessionStorage.getItem("orgDetail"))) {
      let org = await getSelectedOrganization(userInfo.OrganizationId);
      sessionStorage.setItem("orgDetail", Encrypt(org));
      setOrganizationDetail(Decrypt(sessionStorage.getItem('orgDetail')))
    }
    else {
      setOrganizationDetail(Decrypt(sessionStorage.getItem('orgDetail')))
    }
  }


  useEffect(() => {
    setCompaniesListFiltered(organizationId?.length > 0 ? companiesList.filter((item) => item.Name.toLowerCase().includes(organizationId.toLowerCase())) : companiesList);
    setCollegesListFiltered(organizationId?.length > 0 ? collegesList.filter((item) => item.Name.toLowerCase().includes(organizationId.toLowerCase())) : collegesList);
  }
    , [organizationId]);

  useEffect(() => {
    getAdminNotification();
    const role = getRoles(userInfo);
    setRole(role);
    if (role === "Student") {
      getNotification();
    }
    getUserName();

    if (!(sessionStorage.getItem("userDetails"))) {
      getUser();
    }
    else {
      setUserDetails(Decrypt(sessionStorage.getItem('userDetails')));
    }

    if (userInfo.RoleId === ROLE.GROK_ADMIN) {
      setIsSuperAdmin(true);
    }

    if (role === "Company") {
      getOrg();
    }
  }, [reloadHeader])

  return (
    <header className="navbar navbar-expand-md navbar-light  d-print-none">
      <div className="container-fluid">
        <div className="d-md-flex align-items-center col mb-2 mb-md-0">
          <div className="hamburger me-3 d-none d-md-block" onClick={onToggleClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
              <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
            </svg>
          </div>

          {(userInfo.RoleId === ROLE.COMPANY) && <div className="schooltex fw-bold card p-2 px-4 card0-border">
            <p className="OrgLogo-img">{(((organizationDetail && organizationDetail?.Logo) === (null) || (organizationDetail && organizationDetail.LogoURL) === (null)))
              ?
              <img src={require("../../../images/org_logo.png")} alt="logo" width={60} height={60} />
              :
              <img src={organizationDetail && organizationDetail?.Logo} width={60} height={60} style={{ objectFit: "contain" }} title="Logo" />}</p>
            <p className="m-3 orgName" title={organizationDetail && organizationDetail.Name}>{organizationDetail && organizationDetail.Name}</p>
          </div>}
          <div className="col-md-auto mx-auto d-none d-md-block">
            <h4 className="header_title my-2">GROK - INDUSTRY & ACADEMIC COLLABORATION</h4>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between space100 col-md-auto">
          <div>
            <h4 className="mx-3 my-2 persontexthead">{userDetails.Name}</h4>
          </div>
          {(role === "Grok Admin" || role === "Student") && <div className="notification_style" onClick={() => openNotification()}>
            <a className="notification">
              <h4>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.10em" width="1.10em" xmlns="http://www.w3.org/2000/svg"><path d="M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zm144-192v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"></path></svg>
              </h4>
              {
                showNotification ?
                  <span className="badge">{studentNotificationCount < 1 ? "" : studentNotificationCount}</span>
                  :
                  <span className="badge">{notificationCount < 1 ? "" : notificationCount}</span>
              }
            </a>
          </div>}
          <div className="personbox">
            <NavDropdown
              title={
                <span className="personsvg">
                  <div className="avatarimg" title="Profile">
                    {!(userDetails.PhotoURL) || (((userDetails.PhotoURL) === "" || (userDetails.PhotoURL) === null)) ?
                      <img src={require("../../../images/user_pfl-1.png")} width={40} height={40} className="img-fluid header_user_pfl" alt="logo" />
                      :
                      <img src={userDetails.PhotoURL} width={40} height={40} className="img-fluid" alt="logo" />
                    }
                  </div>
                </span>
              }
              id="nav-dropdown"
            >
              <div className="dropdown-item-text">
                <div className="d-flex align-items-center">
                  <div className="avatarimg">
                    {/* <img src={require("../../../images/img1.jpg")} width={50} height={50} className="img-fluid" alt="logo" title="Profile"/> */}

                    {!(userDetails.PhotoURL) || (userDetails.PhotoURL) === "" || userDetails.PhotoURL === null ? (
                      <img src={require("../../../images/img1.jpg")} width={50} height={50} className="img-fluid" alt="logo" title="Profile" />
                    ) : (
                      <img
                        src={userDetails.PhotoURL}
                        className="img-fluid" alt="logo" title="Profile"
                      />
                    )}
                  </div>
                  <div className="flex-grow-1 ms-3">
                    {/* <h5 className="mb-0 persontexthead">{userInfo.Name}</h5> */}
                    <p className="card-text text-body persontextpara">{userDetails.Name}<br />{userDetails.Email}<br />{userDetails.OrganizationId?.Name}</p>
                  </div>
                </div>
              </div>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleShowProfile}>
                <span><svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 14.0902 3.71255 16.014 4.90798 17.5417C6.55245 15.3889 9.14627 14 12.0645 14C14.9448 14 17.5092 15.3531 19.1565 17.4583C20.313 15.9443 21 14.0524 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 21C9.84977 21 7.87565 20.2459 6.32767 18.9878C7.59352 17.1812 9.69106 16 12.0645 16C14.4084 16 16.4833 17.1521 17.7538 18.9209C16.1939 20.2191 14.1881 21 12 21Z" fill="currentColor"></path></svg></span>&nbsp;
                &nbsp; View Profile
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={() => logout()}>
                <span>
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                </span>&nbsp;
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>

      <div>
        <Modal
          show={profileShow}
          onHide={handleCloseProfile}
          backdrop="static"
          keyboard={false}
          className="model-popup" aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {loading ? <GrokLoading /> : ""}
          <Modal.Header closeButton>
            <Modal.Title>
              Profile Information
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="profile-cover">
                <div className="profile-cover-img-wrapper">
                  <img
                    src={require("../../../images/pf_img.jpg")}
                    className="img-fluid profile-banner-img"
                  />
                </div>
              </div>
              <div className="text-center">
                <div className="avatar-img">
                  {!(userDetails.PhotoURL) || (userDetails.PhotoURL) === "" || userDetails.PhotoURL === null ? (
                    <img
                      src={require("../../../images/profile.png")}
                      alt="profile-photo"
                      className="avatar-img img-fluid"
                    />
                  ) : (
                    <img
                      src={userDetails.PhotoURL}
                      className="avatar-img img-fluid"
                      alt="header-logo"
                    />
                  )}
                </div>
                <h4 className="fw-bold batch d-flex align-items-center justify-content-center">{userInfo.Name}</h4>
              </div>
              <hr />
              <Row className="studentdata-view mt-3">
                <Row>
                  <Col className="mb-4">
                    <div className="fw-bold  studhead pb-2">
                      <span style={{ alignItem: "center" }}>User Detail</span>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} sm={3}></Col>
                  <Col>
                    <div> <p>Name : <b>{userDetails.Name}</b></p> </div>
                    <div> <p>Email : <b>{userDetails.Email}</b></p> </div>
                    <div> <p>Contact Number : <b>{userDetails.ContactNumber}</b></p> </div>
                  </Col>
                </Row>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Row>
              <Col>
                <Button variant="secondary" size="sm" type="submit" onClick={handleCloseProfile}>
                  <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"></path></svg></span>&nbsp;
                  Back
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </div>
    </header>
  );
}

export default Header;